// extracted by mini-css-extract-plugin
module.exports = {"transparent":"loader_transparent__3KNfy","imgSpin":"loader_imgSpin__U8uxl","noTransparent":"loader_noTransparent__lgSxp"};